/** Created by azhou on 2019/3/28.*/
<template>
    <div>
      <public-title>收藏管理</public-title>
      <div class="load-area">
        <div class="d-center-between mb-3">
          <el-tabs v-model="collectType" type="card">
            <el-tab-pane label="酒店收藏" name="3" />
            <el-tab-pane label="民宿收藏" name="5" />
            <el-tab-pane label="景区收藏" name="6" />
          </el-tabs>
          <el-input placeholder="酒店/民宿/景区名称..." class="w-30" v-model="searchCon">
            <el-button slot="append" icon="el-icon-search" @click="getList">搜索</el-button>
          </el-input>
        </div>
        <div class="text-left h5 mb-4">共收藏
          <span class="text-danger ml-1 mr-1">{{CollectList.total}}</span>家
          {{collectType | formatVar('StoreType')}}
        </div>
        <p v-if="CollectList.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="Itemize in CollectList.lists" :key="Itemize.id">
            <li class="w-50 list-item-col">
              <span class="text-link" @click="goStoreIndex(Itemize)">{{Itemize.title}}</span></li>
            <li class="w-50 list-item-col">{{Itemize.ctitle}}</li>
            <li class="w-50 list-item-col">{{Itemize.overNum}}</li>
            <li class="w-50 list-item-col-end">
              <span class="text-link" @click="deleteCollect(Itemize)">删除</span>
            </li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                         :total="CollectList.total" :current-page="Number(queryCon.page)"
                         @current-change="$GFUN.pageChange"/>
        </div>
      </div>

    </div>
</template>

<script>
  import { mapGetters,mapState,mapMutations, mapActions } from 'vuex'

  export default {
    name: 'Index',
    computed: {
      ...mapState(['CollectList']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query },
    },
    data() {
      return {
        collectType:'3',
        searchCon:'',
        titleArr:['门店名称','城市','完成的交易','操作']
      }
    },
    watch:{
      collectType(newVal) { this.$router.replace({name:this.$route.query.name,query:{...this.queryCon,type:newVal}}) },
      'queryCon':'getList'
    },
    created() {
      if (this.isGroup) this.UPDATECURRENTSTORE({storeId:this.queryCon.store});
      this.collectType = this.queryCon.type + '';
      this.getList();
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:''});
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getCollectList','cancelCollect']),
      getList() {
        this.getCollectList({
          hotel_name:this.searchCon,
          storeType:this.queryCon.type || '3'
        })
      },
      goStoreIndex(item) {
        switch (this.collectType) {
          case '3': this.$router.push('/index_hotel/hotel_detail/' + item.favId); break;
          case '5': this.$router.push('/index/index_homestay/homestay_detail/' + item.favId); break;
          case '6': this.$router.push('/index/index_scenic/scenic_detail/' + item.favId); break;
        }
      },
      deleteCollect(item) {
        if (!this.$GFUN.powerIsInArray([449])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确定取消收藏么？',() => {
          this.cancelCollect({
            id:item.id,
            successFun:this.getList
          })
        })
      }
    }
  }
</script>
